export const FailureIcon = () => (
  <svg width='90' height='90' viewBox='0 0 90 90' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='90' height='90' rx='12.8571' fill='#F6FAFE' />
    <path
      d='M29.333 26.7575L64.1663 61.5908M60.833 26.5908C60.833 26.5908 38.8505 48.5733 25.833 61.5908'
      stroke='#F23E3E'
      strokeWidth='9.09091'
    />
    <path d='M27.6514 28.4089L62.6514 63.4089M62.6514 28.4089L27.6514 63.4089' stroke='#FF4C4D' strokeWidth='9.09091' />
    <circle cx='67.8027' cy='56.6924' r='8' fill='#FFCE32' />
    <path d='M65.1357 54.0256L70.1357 59.0256M70.1357 54.0256L65.1357 59.0256' stroke='#FF4C4C' strokeWidth='1.55' />
  </svg>
)
